<template>

    <div class="submitterdetail_container">

        <div class="submiterDetail_wrapper d-flex gap-3 flex-wrap">

            <div class="submitterDetails_avatar">

                <img src="../../../assets/images/userimg.svg" class="rounded-circle" />

            </div>

            <div class="submitterDetails_content">

                <div class="d-flex align-items-center submitterDetails_name gap-3 mb-2 flex-wrap">

                    <h3 class="clr-title font-weight-bold mb-0">{{ details.name }}</h3>

                    <span class="submitterDetails_grouptype clr-primary font-13 fw-medium">
                        Group
                    </span>

                </div>

                <div class="submitterDetails_infowrapper d-flex flex-column gap-2">

                    <div class="submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap">

                        <template>

                            <a href="mailto:"
                                class="user_email text-highlight d-flex align-items-center gap-1 clr-primary upload-file-type fw-medium">

                                <span
                                    class="icon d-flex align-items-center justify-content-center flex-shrink-0 text-color fw-normal clr-bold-grey font-14 fw-medium">

                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">

                                        <path fill="currentColor"
                                            d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20zm8-7L4 8v10h16V8zm0-2l8-5H4zM4 8V6v12z" />

                                    </svg>

                                </span>
                                {{ details.email }}
                            </a>

                        </template>

                        <span class="dots"> </span>

                        <template>

                            <a href="tel:"
                                class="user_phonenumber text-highlight d-flex align-items-center gap-1 clr-primary upload-file-type fw-medium">

                                <span
                                    class="icon d-flex align-items-center justify-content-center flex-shrink-0 text-color fw-normal clr-bold-grey font-14">

                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">

                                        <g fill="none" fill-rule="evenodd">

                                            <path
                                                d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />

                                            <path fill="currentColor"
                                                d="M8.172 15.829c3.845 3.845 7.408 4.266 8.454 4.305c1.264.046 2.554-.986 3.112-2.043c-.89-1.044-2.049-1.854-3.318-2.732c-.749.748-1.672 2.138-2.901 1.64c-.699-.281-2.425-1.076-3.933-2.585S7.283 11.18 7 10.482c-.498-1.231.896-2.156 1.645-2.905c-.878-1.29-1.674-2.479-2.716-3.324c-1.072.56-2.11 1.84-2.063 3.121c.039 1.046.46 4.609 4.306 8.455m8.38 6.304c-1.44-.053-5.521-.617-9.795-4.89c-4.273-4.274-4.836-8.354-4.89-9.795c-.08-2.196 1.602-4.329 3.545-5.162a1.47 1.47 0 0 1 1.445.159c1.608 1.173 2.717 2.95 3.67 4.342A1.504 1.504 0 0 1 10.35 8.7l-1.356 1.357C9.309 10.752 9.95 11.95 11 13s2.248 1.691 2.944 2.006l1.355-1.356a1.5 1.5 0 0 1 1.918-.171c1.42.984 3.088 2.077 4.304 3.634a1.47 1.47 0 0 1 .189 1.485c-.837 1.953-2.955 3.616-5.158 3.535" />

                                        </g>

                                    </svg>

                                </span>
                                9468656469
                            </a>

                        </template>

                    </div>

                    <div class="submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap">

                        <div class="clr-title">
                            Register :
                            <span class="clr-bold-grey fw-medium"> N/A</span>

                        </div>

                        <!-- <span class="dots"> </span> -->

                        <div class="clr-title">
                            Reg. date :
                            <span class="clr-bold-grey fw-medium">{{ details.reg_date }}</span>

                        </div>

                    </div>

                    <div class="submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap">

                        <div class="clr-title">
                            Device :
                            <span class="clr-bold-grey fw-medium">{{ details.device }}</span>

                        </div>

                        <!-- <span class="dots"> </span> -->

                        <div class="clr-title">
                            Last Login IP :
                            <span class="clr-bold-grey fw-medium">{{ details.ip_address }}</span>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <!-- // Not Required
        <hr class="my-4" />

        <div class="row">

            <div class="col-lg-6 mb-3">

                <h6 class="fw-semibold clr-title fs-18 mb-3">Group Info</h6>

                <div class="submitterdetail_Infocard p-3">

                    <div class="card--title clr-primary fs-18 font-weight-bold mb-2">John Doe</div>

                    <ul class="card--list d-flex flex-column gap-1 m-0 p-0 list-unstyled">

                        <li class="list-items d-flex gap-2">

                            <span class="list-items--title flex-shrink-0 clr-title fw-medium flex-shrink-0">
                                Group Id :
                            </span>

                            <span class="list-items--value clr-bold-grey fw-normal">
                                12345
                            </span>

                        </li>

                        <li class="list-items d-flex gap-2">

                            <span class="list-items--title clr-title fw-medium flex-shrink-0">
                                Email :
                            </span>

                            <a href="mailto:john.doe@example.com"
                                class="list-items--value  clr-primary upload-file-type">
                                john.doe@example.com
                            </a>

                        </li>

                        <li class="list-items d-flex gap-2">

                            <span class="list-items--title clr-title fw-medium flex-shrink-0">
                                Phone :
                            </span>

                            <a href="tel:+1234567890" class="list-items--value clr-primary upload-file-type">
                                +1234567890
                            </a>

                        </li>

                    </ul>

                </div>

            </div>

            <div class="col-lg-6 mb-3">

                <h6 class="fw-semibold clr-title fs-18 mb-3">Agent Info</h6>

                <div class="submitterdetail_Infocard p-3">

                    <div class="card--title clr-primary fs-18 font-weight-bold mb-2">John Doe</div>

                    <ul class="card--list d-flex flex-column gap-1 m-0 p-0 list-unstyled">

                        <li class="list-items d-flex gap-2">

                            <span class="list-items--title flex-shrink-0 clr-title fw-medium">
                                Agent Id :
                            </span>

                            <span class="list-items--value clr-bold-grey fw-normal">
                                12345
                            </span>

                        </li>

                        <li class="list-items d-flex gap-2">

                            <span class="list-items--title clr-title fw-medium flex-shrink-0">
                                Email :
                            </span>

                            <a href="mailto:john.doe@example.com"
                                class="list-items--value  clr-primary upload-file-type">
                                john.doe@example.com
                            </a>

                        </li>

                        <li class="list-items d-flex gap-2">

                            <span class="list-items--title clr-title fw-medium flex-shrink-0">
                                Phone :
                            </span>

                            <a href="tel:+1234567890" class="list-items--value clr-primary upload-file-type">
                                +1234567890
                            </a>

                        </li>

                    </ul>

                </div>

            </div>

        </div>

        <hr class="mb-0"/>
        <div class="accordion-section  document-section">

            <b-card>

                <div class="accordion-item">

                    <b-card-header class="border-0 p-0">

                        <b-button v-b-toggle.accordion1 variant="link"
                            class="w-100 d-flex justify-content-between align-items-center gap-3 px-0 py-3 fs-18 clr-title fw-semibold text-decoration-none">
                            Member Documents
                            <span class="icon-wrapper clr-bold-grey fs-16">

                                <i class="fas fa-angle-down"></i>

                            </span>

                        </b-button>

                    </b-card-header>

                    <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel" class="mt-2 mb-4">

                        <b-card-body>

                          
                            <Carousel :perPage="3" :scrollPerPage="true" :navigationEnabled="false" :paginationEnabled="true"    :perPageCustom="[[0, 1], [768, 2], [1024, 3]]">
                                <Slide>
                                     <div class="ticket_documentInfo d-flex align-items-center gap-3 h-100">

                                    <div class="icon-wrapper flex-shrink-0">

                                        <img src="./../../../assets/images/pdf.svg" alt="pdf icon"
                                            class="w-100 h-100" />

                                    </div>

                                    <div class="document_content d-flex flex-column gap-1 flex-grow-1">

                                        <a href=""
                                            class="document_link d-flex align-items-center gap-1 justify-content-between">

                                            <span class="document_name clr-primary fs-16 fw-semibold">
                                                Medical Records.pdf
                                            </span>

                                            <span
                                                class="link_icon d-flex align-items-center justify-content-center clr-primary font-14">

                                                <i class="fas fa-external-link-alt"></i>

                                            </span>

                                        </a>

                                        <div class="document_info d-flex align-items-center gap-2 flex-wrap font-14">

                                            <span class="document_type clr-bold-grey">PDF</span>

                                            <span class="dots"> </span>

                                            <span class="document_datewrapper clr-title fw-medium">
                                                Uploaded :
                                                <span class="document_date clr-bold-grey fw-normal">
                                                    04/16/2023
                                                </span>

                                            </span>

                                        </div>

                                    </div>

                                </div>
                                </Slide>
                                 <Slide>
                                     <div class="ticket_documentInfo d-flex align-items-center gap-3 h-100">

                                    <div class="icon-wrapper flex-shrink-0">

                                        <img src="./../../../assets/images/pdf.svg" alt="pdf icon"
                                            class="w-100 h-100" />

                                    </div>

                                    <div class="document_content d-flex flex-column gap-1 flex-grow-1">

                                        <a href=""
                                            class="document_link d-flex align-items-center gap-1 justify-content-between">

                                            <span class="document_name clr-primary fs-16 fw-semibold">
                                                Medical Records.pdf
                                            </span>

                                            <span
                                                class="link_icon d-flex align-items-center justify-content-center clr-primary font-14">

                                                <i class="fas fa-external-link-alt"></i>

                                            </span>

                                        </a>

                                        <div class="document_info d-flex align-items-center gap-2 flex-wrap font-14">

                                            <span class="document_type clr-bold-grey">PDF</span>

                                            <span class="dots"> </span>

                                            <span class="document_datewrapper clr-title fw-medium">
                                                Uploaded :
                                                <span class="document_date clr-bold-grey fw-normal">
                                                    04/16/2023
                                                </span>

                                            </span>

                                        </div>

                                    </div>

                                </div>
                                </Slide>
                                 <Slide>
                                     <div class="ticket_documentInfo d-flex align-items-center gap-3 h-100">

                                    <div class="icon-wrapper flex-shrink-0">

                                        <img src="./../../../assets/images/pdf.svg" alt="pdf icon"
                                            class="w-100 h-100" />

                                    </div>

                                    <div class="document_content d-flex flex-column gap-1 flex-grow-1">

                                        <a href=""
                                            class="document_link d-flex align-items-center gap-1 justify-content-between">

                                            <span class="document_name clr-primary fs-16 fw-semibold">
                                                Medical Records.pdf
                                            </span>

                                            <span
                                                class="link_icon d-flex align-items-center justify-content-center clr-primary font-14">

                                                <i class="fas fa-external-link-alt"></i>

                                            </span>

                                        </a>

                                        <div class="document_info d-flex align-items-center gap-2 flex-wrap font-14">

                                            <span class="document_type clr-bold-grey">PDF</span>

                                            <span class="dots"> </span>

                                            <span class="document_datewrapper clr-title fw-medium">
                                                Uploaded :
                                                <span class="document_date clr-bold-grey fw-normal">
                                                    04/16/2023
                                                </span>

                                            </span>

                                        </div>

                                    </div>

                                </div>
                                </Slide>
                                 <Slide>
                                     <div class="ticket_documentInfo d-flex align-items-center gap-3 h-100">

                                    <div class="icon-wrapper flex-shrink-0">

                                        <img src="./../../../assets/images/pdf.svg" alt="pdf icon"
                                            class="w-100 h-100" />

                                    </div>

                                    <div class="document_content d-flex flex-column gap-1 flex-grow-1">

                                        <a href=""
                                            class="document_link d-flex align-items-center gap-1 justify-content-between">

                                            <span class="document_name clr-primary fs-16 fw-semibold">
                                                Medical Records.pdf
                                            </span>

                                            <span
                                                class="link_icon d-flex align-items-center justify-content-center clr-primary font-14">

                                                <i class="fas fa-external-link-alt"></i>

                                            </span>

                                        </a>

                                        <div class="document_info d-flex align-items-center gap-2 flex-wrap font-14">

                                            <span class="document_type clr-bold-grey">PDF</span>

                                            <span class="dots"> </span>

                                            <span class="document_datewrapper clr-title fw-medium">
                                                Uploaded :
                                                <span class="document_date clr-bold-grey fw-normal">
                                                    04/16/2023
                                                </span>

                                            </span>

                                        </div>

                                    </div>

                                </div>
                                </Slide>
                            </Carousel>

                        </b-card-body>

                    </b-collapse>

                </div>

                <div class="accordion-item">

                    <b-card-header class="border-0 p-0">

                        <b-button v-b-toggle.accordion2 variant="link"
                            class="w-100 d-flex justify-content-between align-items-center gap-3 px-0 py-3 fs-18 clr-title fw-semibold text-decoration-none">
                            Plans Names
                            <span class="icon-wrapper clr-bold-grey fs-16">

                                <i class="fas fa-angle-down"></i>

                            </span>

                        </b-button>

                    </b-card-header>

                    <b-collapse id="accordion2" visible accordion="my-accordion" role="tabpanel" class="mt-2 mb-4">

                        <b-card-body>

                            <div class="row planInfo__card--list">

                                <div class="col-lg-4 col-md-6 mb-3">

                                    <span class="plan_name heading-color clr-title">
                                        Administration Fees (IO)
                                    </span>

                                </div>
                                  <div class="col-lg-4 col-md-6 mb-3">

                                    <span class="plan_name heading-color clr-title">
                                        Administration Fees (IO)
                                    </span>

                                </div>
                                  <div class="col-lg-4 col-md-6 mb-3">

                                    <span class="plan_name heading-color clr-title">
                                        Administration Fees (IO)
                                    </span>

                                </div>
                                  <div class="col-lg-4 col-md-6 mb-3">

                                    <span class="plan_name heading-color clr-title">
                                        Administration Fees (IO)
                                    </span>

                                </div>
                                  <div class="col-lg-4 col-md-6 mb-3">

                                    <span class="plan_name heading-color clr-title">
                                        Administration Fees (IO)
                                    </span>

                                </div>
                                  <div class="col-lg-4 col-md-6 mb-3">

                                    <span class="plan_name heading-color clr-title">
                                        Administration Fees (IO)
                                    </span>

                                </div>

                                

                            </div>

                        </b-card-body>

                    </b-collapse>

                </div>

                <div class="accordion-item">

                    <b-card-header class="border-0 p-0">

                        <b-button v-b-toggle.accordion3 variant="link"
                            class="w-100 d-flex justify-content-between align-items-center gap-3 px-0 py-3 fs-18 clr-title fw-semibold text-decoration-none">
                            Systems ids
                            <span class="icon-wrapper clr-bold-grey fs-16">

                                <i class="fas fa-angle-down"></i>

                            </span>

                        </b-button>

                    </b-card-header>

                    <b-collapse id="accordion3" visible accordion="my-accordion" role="tabpanel" class="mt-2 mb-4">

                        <b-card-body>

                            <div class="systemId_wrapper d-flex gap-3 flex-wrap align-items-center">

                                <span
                                    class="systemId_name d-inline-flex align-items-center justify-content-center  py-2 px-3 border clr-title fw-medium font-14 rounded">
                                    4365
                                </span>
                                 <span
                                    class="systemId_name d-inline-flex align-items-center justify-content-center  py-2 px-3 border clr-title fw-medium font-14 rounded">
                                    4365
                                </span>
                                 <span
                                    class="systemId_name d-inline-flex align-items-center justify-content-center  py-2 px-3 border clr-title fw-medium font-14 rounded">
                                    4365
                                </span>
                                 <span
                                    class="systemId_name d-inline-flex align-items-center justify-content-center  py-2 px-3 border clr-title fw-medium font-14 rounded">
                                    4365
                                </span>
                                 <span
                                    class="systemId_name d-inline-flex align-items-center justify-content-center  py-2 px-3 border clr-title fw-medium font-14 rounded">
                                    4365
                                </span>
                                 <span
                                    class="systemId_name d-inline-flex align-items-center justify-content-center  py-2 px-3 border clr-title fw-medium font-14 rounded">
                                    4365
                                </span>
                                 <span
                                    class="systemId_name d-inline-flex align-items-center justify-content-center  py-2 px-3 border clr-title fw-medium font-14 rounded">
                                    4365
                                </span>

                               
                            </div>

                        </b-card-body>

                    </b-collapse>

                </div>

            </b-card>

        </div> -->

    </div>

</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: "TicketSubmitterDetail",
    // components: {  Carousel,
    // Slide},
    props: {
        submitterDetails: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            details: this.submitterDetails
        }
    },
    methods: {
        onSlideStart() { this.sliding = true; }, onSlideEnd() { this.sliding = false; }
    }
};
</script>

<style scoped>
.submiterDetail_wrapper .submitterDetails_avatar img {
    width: 52px;
    height: 52px;
}

.submiterDetail_wrapper .submitterDetails_content .submitterDetails_grouptype {
    border: 1px solid var(--rep-primary-clr);
    background: #03c3ec10;
    padding: 4px 12px;
    border-radius: 30px;
}

.submitterDetails_info--items .text-highlight .icon {
    color: var(--rep-bold-grey-clr) !important;
}

.submitterdetail_container .dots {
    background-color: #a6a6a6;
    width: 5px;
    height: 5px;
    border-radius: 50%;
}
.ticket-manage-wrapper .accordion-section .planInfo__card--list .plan_name {
    display: list-item;
    list-style-type: disc;
    margin-left: 15px;
}

.ticket-manage-wrapper .accordion-section .card {
    border: 0;
    border-radius: 0;
    box-shadow: none;
}

.ticket-manage-wrapper .accordion-section .card .card-body {
    padding: 0;
    border-radius: 0;
    border: 0;
}

.ticket-manage-wrapper .accordion-section .card .card-body .accordion-item {
    border: 0 !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18) !important;
    border-radius: 0;
}

.ticket-manage-wrapper .accordion-section .card .card-body .accordion-item .card-header {
    background-color: #fff !important;
}

.ticket-manage-wrapper .accordion-section .card .card-body .accordion-item .card-header button.not-collapsed .icon-wrapper {
    transform: rotate(180deg);
}

.ticket-manage-wrapper .accordion-section .card .card-body .accordion-item .card-header button, .accordion-section .card .card-body .accordion-item .card-header button:hover ,  .accordion-section .card .card-body .accordion-item .card-header button:active{
    outline: none;
    box-shadow: none;
    color: var(--rep-title-clr);
    border: 0;
}

.document-section .ticket_documentInfo {
    padding: 16px;
    border: 1px solid #d7e1ea;
    border-radius: 6px;
    margin-right: 16px;
}

.document-section .ticket_documentInfo .icon-wrapper {
    width: 34px;
}

.submitterdetail_container a , .submitterdetail_container a:hover{
    text-decoration: none;
    color: var(--rep-primary-clr);
}
</style>
